MealRecipeModel.$inject = ["$modelFactory", "MealRecipeIngredientModel", "TagModel", "ImageModel", "ApiHttp", "RecipeModel", "$q"];function _typeof(obj) {if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {_typeof = function _typeof(obj) {return typeof obj;};} else {_typeof = function _typeof(obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;};}return _typeof(obj);}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}function _possibleConstructorReturn(self, call) {if (call && (_typeof(call) === "object" || typeof call === "function")) {return call;}return _assertThisInitialized(self);}function _assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}export var mealRecipeDefaults = {
  id: 0,
  meal_recipe_ingredients: [/* {MealRecipeIngredientModel} */],
  template_recipe_ingredients: [/* {MealRecipeIngredientModel} */],
  tags: [/* {TagModel} */],
  image: null, /* ImageModel */
  name: "",
  directions: "",
  difficulty: "",
  prep_time: 0,
  cook_time: 0,
  special_notes: "",
  free_foods: "",
  seasonings: null };


export function MealRecipeModel(
$modelFactory,
MealRecipeIngredientModel,
TagModel,
ImageModel,
ApiHttp,
RecipeModel,
$q)
{
  "ngInject";var

  Recipe = /*#__PURE__*/function (_$modelFactory) {_inherits(Recipe, _$modelFactory);function Recipe() {_classCallCheck(this, Recipe);return _possibleConstructorReturn(this, (Recipe.__proto__ || Object.getPrototypeOf(Recipe)).apply(this, arguments));}_createClass(Recipe, [{ key: "getTemplateRecipeByName", value: function getTemplateRecipeByName(
































      id) {
        return Recipe.getTemplateRecipeByName(id);
      } }], [{ key: "getTemplateRecipeByName", value: function getTemplateRecipeByName(id) {var mealRecipe = this.get(id);var recipes = RecipeModel.query();var filteredRecipe = $q.all([mealRecipe, recipes]).then(function (res) {return res[1].filter(function (item) {return item.name === res[0].name;});});return filteredRecipe;} }]);return Recipe;}($modelFactory(ApiHttp.mealRecipes, { defaults: mealRecipeDefaults, map: { meal_recipe_ingredients: MealRecipeIngredientModel.List, template_recipe_ingredients: MealRecipeIngredientModel.List, tags: TagModel.List, image: ImageModel }, actions: { 'get': { cache: true }, 'query': { isArray: true, cache: true, afterRequest: function afterRequest(response) {var _this = this;response.forEach(function (item, i) {_this.cache.put("".concat(_this.url).concat(item.id, "/"), item);});return response;} } } }));

  Recipe.List.Model = Recipe;

  return Recipe;

}